package com.cybersoftsolution.cybersoftsolutionweb.components.toast

import androidx.compose.runtime.Composable
import com.cybersoftsolution.cybersoftsolutionweb.models.Theme
import com.stevdza.san.kotlinbs.components.BSButton
import com.stevdza.san.kotlinbs.models.BorderColor
import com.stevdza.san.kotlinbs.models.ToastStyle
import com.stevdza.san.kotlinbs.models.button.ButtonSize
import com.stevdza.san.kotlinbs.models.button.ButtonVariant
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.attrsModifier
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.classNames
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.thenIf
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.text.SpanText
import kotlinx.browser.document
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch
import org.jetbrains.compose.web.attributes.disabled
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Button
import org.jetbrains.compose.web.dom.Div
import org.w3c.dom.HTMLDivElement


fun CoroutineScope.showMyToast(toastId: String) {
    launch {
        hideToast(toastId)
        delay(100)
        showToast(toastId)

    }
}

@Composable
fun MyToastAction(
    modifier: Modifier = Modifier,
    id: String,
    text: String,
    positiveButtonText: String = "Take Action",
    negativeButtonText: String = "Close",
    autoHide: Boolean = false,
    onPositiveButtonClick: () -> Unit,
    onNegativeButtonClick: () -> Unit,
    style: ToastStyle = ToastStyle.Link,
    borderColor: BorderColor? = null,
    positiveButtonVariant: ButtonVariant = ButtonVariant.Primary,
    negativeButtonVariant: ButtonVariant = ButtonVariant.Secondary,
) {
    Div(
        attrs = modifier
            .id(id)
            .zIndex(9)
            .classNames("toast", style.value)
            .styleModifier {
                property("pointer-events", "auto")
            }
            .toAttrs {
                attr("role", "alert")
                attr("aria-live", "assertive")
                attr("aria-atomic", "true")
                attr("data-bs-autohide", autoHide.toString())
            }
    ) {
        Div(
            attrs = Modifier.classNames("toast-body").toAttrs(),
        ) {
            SpanText(text = text)
            Row(
                modifier = Modifier
                    .classNames("mt-2", "pt-2", "border-top")
                    .thenIf(
                        condition = borderColor != null,
                        other = Modifier.classNames(borderColor?.value ?: "")
                    )
            ) {
                BSButton(
                    modifier = Modifier
                        .attrsModifier {
                            attr("data-bs-dismiss", "toast")
                        },
                    text = positiveButtonText,
                    size = ButtonSize.Small,
                    variant = positiveButtonVariant,
                    onClick = onPositiveButtonClick
                )
                BSButton(
                    modifier = Modifier
                        .margin(left = 8.px)
                        .attrsModifier {
                            attr("data-bs-dismiss", "toast")
                        },
                    text = negativeButtonText,
                    size = ButtonSize.Small,
                    variant = negativeButtonVariant,
                    onClick = onNegativeButtonClick
                )
            }
        }
    }
}


@Composable
fun MyToastMessage(
    modifier: Modifier = Modifier,
    style: MyToastStyle = MyToastStyle.Primary,
    id: String,
    message: String,
    autoHide: Boolean = true,
    dark: Boolean = false,
    border: Int = 0,
    onCloseClick: () -> Unit = {},
    closeButtonDisabled: Boolean = false,
){
    Div(
        attrs = Modifier
            .then(modifier)
            .boxShadow(
                offsetX = 0.px,
                offsetY = 0.px,
                blurRadius = 5.px,
                spreadRadius = 1.px,
                color = Theme.HalfBlack.rgb
            )
            .border(
                width = border.px,
                style = LineStyle.Solid,
                color = Theme.HalfBlack.rgb
            )
            .id(id)
            .zIndex(9)
            .classNames("toast", style.value,  "border-${border}")
            .styleModifier {
                property("pointer-events", "auto")
            }
            .toAttrs {
                attr("role", "alert")
                attr("aria-live", "assertive")
                attr("aria-atomic", "true")
                attr("data-bs-autohide", autoHide.toString())
            }
    ) {
        Row(
            modifier = Modifier.classNames("toast-body"),
            horizontalArrangement = Arrangement.SpaceBetween
        ) {
            SpanText(text = message)

            Button(attrs = Modifier
                    .onClick { onCloseClick() }
                .attrsModifier {
                    attr("data-bs-dismiss", "toast")
                }
                .classNames("btn-close")
                .thenIf(
                    condition = !dark,
                    other = Modifier.classNames("btn-close-white")
                )
                .toAttrs {
                    attr("type", "button")
                    attr("aria-label", "Close")
                    if (closeButtonDisabled) disabled()
                }
            )

        }
    }
}



fun showToast(toastId: String) {
    try {
        val toastElement = (document.getElementById(toastId) as HTMLDivElement)
        val jsCode = """
            const toastBootstrap = bootstrap.Toast.getOrCreateInstance(toastElement);
            toastBootstrap.show();
        """.trimIndent()
        js("eval(jsCode)") //as Unit no es necesario cuando se usa asu la llamada del js
    } catch (e: Exception) {
        println("showToast: ${e.message} ${e.cause}")
    }
}

fun hideToast(toastId: String) {
    try {
        val toastElement = (document.getElementById(toastId) as HTMLDivElement)
        val jsCode = """
            const toastBootstrap = bootstrap.Toast.getOrCreateInstance(toastElement);
            toastBootstrap.dispose();
        """.trimIndent()
        js("eval(jsCode)") //as Unit no es necesario cuando se usa asu la llamada del js
    } catch (e: Exception) {
        println("hideToast: ${e.message} ${e.cause}")
    }
}
//
//fun showToast(toastId: String) {
//    try {
//        val toastElement = (document.getElementById(toastId) as HTMLDivElement)
//        val jsCode = """
//            const toast = new bootstrap.Toast(toastElement);
//            toast.show();
//        """.trimIndent()
//        js("eval(jsCode)") as Unit
//    } catch (e: Exception) {
//        println("showToast: ${e.message}")
//    }
//}

enum class MyToastStyle(val value: String) {
    Primary(value = "text-bg-primary"),
    Secondary(value = "text-bg-secondary"),
    Success(value = "text-bg-success"),
    Danger(value = "text-bg-danger"),
    Warning(value = "text-bg-warning"),
    Info(value = "text-bg-info"),
    Light(value = "text-bg-light"),
    Dark(value = "text-bg-dark"),
    Link(value = "text-bg-link")
}
